// extracted by mini-css-extract-plugin
export default {"pages":"pages_pages__exkEH","title":"pages_title__Li8KL","block":"pages_block__z1Nhm","blinker":"pages_blinker__i3hn+","eggs":"pages_eggs__ICt+0"};